module.exports = __webpack_public_path__ + "img/switch-horizontal-with-circle.ba2f485c.png";